/**
 * This represents metadata of some object.
 */
export interface TargetMetadata {

    /**
     * Target class to which metadata is applied.
     */
    readonly target: Function|string;

}
